import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: ${props => (props.active ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 55px;
`;

export const ContainerMain = styled.div`
  max-width: 980px;
  width: 980px;
  display: flex;
  justify-content: space-between;
  gap: 8px;

  @media only screen and (max-width: 950px) {
    flex-direction: column;
    align-items: center;
    max-width: 100%;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  svg {
    width: 30px;
    color: #344563;
    opacity: 0.85;
  }

  h2 {
    font-style: normal;
    font-weight: 100;
    font-size: 20px;
    line-height: 25px;
    text-align: left;
    color: #475467;
  }

  @media only screen and (max-width: 950px) {
    svg {
      width: 15px;
      color: #344563;
      opacity: 0.85;
    }

    h2 {
      font-style: normal;
      font-weight: 100;
      font-size: 16px;
      line-height: 25px;
      text-align: center;
      color: #475467;
    }
  }
`;
